import { getHighlightRowSizes } from './get-highlight-row-sizes';

// Literal classes, so Tailwind can see them. Keyed by how many cards share the row.
const WIDE_COLUMN_SPAN_BY_ROW_SIZE: Record<number, string> = {
  1: '@min-[60rem]:col-span-12',
  2: '@min-[60rem]:col-span-6',
  3: '@min-[60rem]:col-span-4',
  4: '@min-[60rem]:col-span-3',
};

/**
 * The highlight rows beside a leading card. Until the section is 60rem wide, three stats beside the card
 * can't fit their titles, so they go two to a row on a two-column grid, an odd last one taking the whole
 * row. From there, the usual rows on a 12-column grid.
 */
export const getHighlightColumnSpansBesideCard = (count: number) =>
  getHighlightRowSizes(count)
    .flatMap((size) => Array.from({ length: size }, () => WIDE_COLUMN_SPAN_BY_ROW_SIZE[size]))
    .map((wideSpan, index) => (count % 2 === 1 && index === count - 1 ? `md:col-span-2 ${wideSpan}` : wideSpan));
